import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "preact/jsx-runtime";
import Spinner from '@fandom-frontend/react-common/dist/components/Spinner';
import GenericModal, { ModalCloseButtonPlacement } from 'pathfinder/modules/shared/GenericModal/GenericModal';
import QuizConsumption from 'pathfinder/modules/shared/QuizConsumption';
import { Suspense } from 'react';
import QuizModalCloseButton from 'pathfinder/modules/QuizConsumptionModule/shared/QuizModalCloseButton';
import { useQuizStore } from 'pathfinder/modules/shared/QuizConsumption/store/quizConsumptionStore';
import { validateQuizAnswersFromQuizId } from 'pathfinder/api/quizzes';
const overrideModalCSS = {
    alignItems: 'center',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    padding: '0.01px',
    flexDirection: 'column',
    width: 'fit-content',
    margin: '0 auto',
};
const overrideModalBodyCSS = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '6px',
    overflow: 'hidden',
};
const extraModalFadeInCSSStyles = {
    alignItems: 'center',
    display: 'flex',
};
export const FeaturedQuizModal = (_a) => {
    var { openButtonElement, onOpen, onClose, quizImpression, shouldAutoOpen } = _a, props = __rest(_a, ["openButtonElement", "onOpen", "onClose", "quizImpression", "shouldAutoOpen"]);
    const [quizId, userAnswers, resetQuiz] = useQuizStore((state) => [
        state.getQuizId(),
        state.userQuizAnswers,
        state.resetQuiz,
    ]);
    const onCloseModal = () => {
        if (userAnswers.length) {
            validateQuizAnswersFromQuizId(quizId, userAnswers);
        }
        if (typeof onClose === 'function') {
            onClose();
        }
        resetQuiz();
    };
    return (_jsx(_Fragment, { children: _jsx(GenericModal, Object.assign({ overrideModalCSSStyles: overrideModalCSS, overrideModalBodyCSSStyles: overrideModalBodyCSS, openButtonElement: openButtonElement, closeButtonPlacement: ModalCloseButtonPlacement.AboveModalBody, modalCloseElement: _jsx(QuizModalCloseButton, {}, void 0), extraModalFadeInCSSStyles: extraModalFadeInCSSStyles, disableHeaderElement: true, onOpen: onOpen, onClose: onCloseModal, modalImpression: quizImpression, shouldAutoOpen: shouldAutoOpen }, { children: _jsx(Suspense, Object.assign({ fallback: _jsx(Spinner, { size: 24 }, void 0) }, { children: _jsx(QuizConsumption, Object.assign({}, props, { questionTimer: 20, initialQuestionIndex: 0 }), void 0) }), void 0) }), void 0) }, void 0));
};
